import { api } from "./http-client";
import { JobRunListResponse, JobRunPageOptionsDto, JobRun } from "../types/job-run";

export const jobRunsService = {
  async list(params?: JobRunPageOptionsDto): Promise<JobRunListResponse> {
    const response = await api.request<JobRunListResponse>({
      url: "/job-runs",
      method: "GET",
      params,
    });
    return response.data;
  },
  async runForSource(sourceId: string): Promise<JobRun> {
    const response = await api.request<JobRun>({
      url: `/job-runs/run/source/${sourceId}`,
      method: "POST",
    });
    return response.data;
  },
  async getOne(id: string): Promise<JobRun> {
    const response = await api.request<JobRun>({
      url: `/job-runs/${id}`,
      method: "GET",
    });
    return response.data;
  },
};

